import { useState } from "react";
import { useGetPeriodicals } from "../api/useGetPeriodicals";
import { AutoComplete } from "./AutoComplete";

export const PeriodicalDropdown = ({ formData }) => {
  const [keyword, setKeyword] = useState("");
  const periodicals = useGetPeriodicals(keyword, formData);

  const onSelectSuggestion = (periodical) => () => {
    setKeyword("");
    formData.periodicals.onChange({ target: { value: periodical.value } });
  };

  return (
    <AutoComplete
      placeholder={formData.periodicals.values?.[0]}
      keyword={keyword}
      setKeyword={setKeyword}
      suggestions={periodicals}
      onSelectSuggestion={onSelectSuggestion}
      // disabled={!periodicals?.length}
    />
  );
};
